import Decline from './Decline';

export default Decline;
